import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import IntegrationHooks from './IntegrationHooks.vue';
import Index from './Index.vue';
import Webhook from './Webhooks/Index.vue';
import DashboardApps from './DashboardApps/Index.vue';
import Slack from './Slack.vue';
import Linear from './Linear.vue';
import Notion from './Notion.vue';
import Shopify from './Shopify.vue';

// ACESSO-01 (L8b): conectar e configurar integrações, webhooks e apps do painel (`hooks#create`, `webhooks#*`,
// `dashboard_apps#*`), travado: o super admin.
const ESCOPOS_DAS_INTEGRACOES = ['integrations:manage'];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      // `superAdminOnly` no PAI, não em cada filho: o guard do router faz
      // `to.matched.some(...)`, que olha pai e filho. Marcando aqui, toda tela de integração
      // — inclusive uma que alguém adicione amanhã — já nasce guardada. Até 22/09/2026 só a
      // grade era marcada, e as telas de dentro (webhooks, HubSpot) abriam por link direto
      // para qualquer administrador de conta.
      meta: { superAdminOnly: true },
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            superAdminOnly: true,
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      // Mesmo motivo do bloco acima: Slack, Linear, Notion e Shopify também são configuração
      // de plataforma.
      meta: { superAdminOnly: true },
      children: [
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
          props: route => ({ error: route.query.error }),
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
            escopos: ESCOPOS_DAS_INTEGRACOES,
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
